module.exports = __webpack_public_path__ + "media/images/icon__betPick--none-e1a10b0c009b65e93bd89ef9006b707e.png";